package br.com.vvrefeicoes.portal.core.ui.layout

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing

@Composable
actual fun AppScrollColumn(
    modifier: Modifier,
    state: ScrollState,
    contentPadding: PaddingValues,
    verticalArrangement: Arrangement.Vertical,
    horizontalAlignment: Alignment.Horizontal,
    footer: (@Composable () -> Unit)?,
    content: @Composable ColumnScope.() -> Unit,
) {
    BoxWithConstraints(modifier = modifier) {
        val minHeight = maxHeight
        Column(
            modifier =
                Modifier
                    .fillMaxSize()
                    .verticalScroll(state),
            horizontalAlignment = horizontalAlignment,
        ) {
            if (footer == null) {
                Column(
                    modifier = Modifier.fillMaxWidth().padding(contentPadding),
                    verticalArrangement = verticalArrangement,
                    horizontalAlignment = horizontalAlignment,
                    content = content,
                )
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth().heightIn(min = minHeight),
                    verticalArrangement = Arrangement.SpaceBetween,
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth().padding(contentPadding),
                        verticalArrangement = verticalArrangement,
                        horizontalAlignment = horizontalAlignment,
                        content = content,
                    )
                    footer()
                }
            }
        }
        AppScrollbar(
            state = state,
            modifier =
                Modifier
                    .align(Alignment.CenterEnd)
                    .fillMaxHeight()
                    .padding(vertical = AppSpacing.space8),
        )
    }
}
